window.constrain = function (aNumber, aMin, aMax) {
	return aNumber > aMax ? aMax : aNumber < aMin ? aMin : aNumber;
};

window.getURLParameter = function (name) {
	return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
};

window.millis = function() {
	return Date.now();
}

window.getDate = function (language) {

	var objToday = new Date();
	var weekday, dayOfWeek, domEnder, dayOfMonth, months, curMonth, curYear, curHour, curMinute, curSeconds, curMeridiem, dayOfMonthNoEnd;

	if (language == "fr") {
		objToday = new Date();
		weekday = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
		months = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juilet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
	} else {
		objToday = new Date();
		weekday = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
		months = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
	}

	domEnder = new Array('th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th');
	dayOfWeek = weekday[objToday.getDay()];
	dayOfMonthNoEnd = objToday.getDate();
	dayOfMonth = (objToday.getDate() < 10) ? '0' + objToday.getDate() + domEnder[objToday.getDate()] : objToday.getDate() + domEnder[parseFloat(("" + objToday.getDate()).substr(("" + objToday.getDate()).length - 1))];
	curMonth = months[objToday.getMonth()];
	curYear = objToday.getFullYear();
	curHour = objToday.getHours() > 12 ? objToday.getHours() - 12 : (objToday.getHours() < 10 ? "0" + objToday.getHours() : objToday.getHours());
	curMinute = objToday.getMinutes() < 10 ? "0" + objToday.getMinutes() : objToday.getMinutes();
	curSeconds = objToday.getSeconds() < 10 ? "0" + objToday.getSeconds() : objToday.getSeconds();
	curMeridiem = objToday.getHours() > 12 ? "PM" : "AM";

	if (language == "fr") {
		//return (dayOfWeek + " " + dayOfMonthNoEnd + " " + curMonth + " " + curYear);
		return (dayOfWeek + " " + dayOfMonthNoEnd + " " + curMonth );
	} else if (language == "hour") {
		return (curHour + ":" + curMinute + " " + curMeridiem );
	} else {
		//return (dayOfWeek + " " + curMonth + " " + dayOfMonth + " " + curYear);
		return (dayOfWeek + " " + curMonth + " " + dayOfMonth);
	}
};
